<template>
  <Forms ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="onClearSection"
            v-on:Search="Search"
          >
          <div class="w-100">
            <label class="label-search">Situação:</label>
            <select v-model="form.situacao.value" class="form-control">
                <option :value="null">Selecione</option>
                <option v-for="data in dataSituacao" :key="data.value" :value="data.value">{{data.text}}</option>
            </select>
            <label  class="label-search">Obra:</label>
            <autocomplete-z ref="obraRHTypeahead"
                placeholder="Digite o nome da Obra"
                type="text"
                iconClass="fas fa-hard-hat"
                :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
                :debounceLength="2"
                :formField="form.obraid"
                v-on:search="onSearchObra"
                v-on:changeCode="onChangeCodeObra"/>
              <label v-if="!flDespesas" class="label-search">Codigo Lote:</label>
              <label v-if="flDespesas" class="label-search">Codigo Lote Reembolso:</label>
              <autocomplete-z ref="termoLoteTypehead"
                placeholder="Digite o nome do arquivo do lote"
                type="text"
                v-show="!flDespesas"
                iconClass="fas fa-file-excel"
                :serializer="(TermoLog) => TermoLog.nomeArquivo"
                :debounceLength="2"
                :formField="form.despesaLog"
                v-on:search="GetTermoLog"
                v-on:changeCode="onChangeCodeTermoLog"/>
              <autocomplete-z ref="despesaLog"
                placeholder="Digite o nome do   arquivo do lote"
                type="text"
                v-show="flDespesas"
                iconClass="fas fa-file-excel"
                :serializer="(despesaLog) => despesaLog.nomeArquivo"
                :debounceLength="2"
                :formField="form.despesaLog"
                v-on:search="GetDespesaLog"
                v-on:changeCode="onChangeCodeDespesaLog"/>
                <label v-if="flDespesas" class="label-search">Codigo Lote Desconto:</label>
                 <autocomplete-z ref="descontoLog"
                placeholder="Digite o nome do   arquivo do lote"
                type="text"
                v-show="flDespesas"
                iconClass="fas fa-file-excel"
                :serializer="(despesaLog) => despesaLog.nomeArquivo"
                :debounceLength="2"
                :formField="form.despesaDescontoLote"
                v-on:search="GetDespesaDescontoLog"
                v-on:changeCode="onChangeCodeDespesaDescontoLog"/>
            <label class="label-search">Responsavel:</label>
            <autocomplete-z ref="responsavelTypeahead"
                placeholder="Digite o nome do Responsável"
                iconClass="fas fa-users"
                :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                :debounceLength="3"
                :formField="form.responsavelId"
                v-on:search="onSearchResponsavel"
                v-on:changeCode="onChangeCodeResponsavel" />
            <label class="label-search">Funcionário:</label>
            <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="form.funcionarioId"
                :returnCallback="true"
                v-on:search="onSearchFavorecido"
                v-on:hit="changeByName"
                v-on:changeCode="onChangeCodeFavorecido" />
            <label class="label-search">Regional:</label>
           <div class="d-flex">
             <b-form-input type="text"
                class="col-2 text-upper"
                style="height: calc(2.09375rem + 2px);border-right: 0px;"
                :placeholder="'Código'"
                v-model="form.secaoRH.value"
                :size="form.secaoRH.maxlength"
                :state="form.secaoRH.state"
                @focus="onClearSection"
                v-on:change="onChangeCodeSection"/>
                <select v-model="form.secaoRH.value" class="form-control">
                  <option :value="null">Selecione</option>
                  <option v-for="data in allRegional" :key="data.id" :value="data.id">{{data.nome}}</option>
                </select>
           </div>
            <label class="label-search">Grupo Solicitante:</label>
            <select v-model="form.grupoSolicitante.value" class="form-control">
                <option :value="null">Selecione</option>
                <option v-for="data in dataGrupoSolicitante" :key="data.value" :value="data.value">{{data.text}}</option>
            </select>
          </div>
        </Forms>
</template>

<script>
import SearchTravelAdvance from './SearchTravelAdvance'
export default SearchTravelAdvance
</script>

<style scoped>
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/SearchTravelAdvance/SearchTravelAdvance.vue